import axios from 'axios'
import app from './main'
let count = 0

axios.interceptors.request.use(config => {
  !count && app.$Progress.start();
  count++
  // alert(config)
  return config;
});

axios.interceptors.response.use(response => {
  count--
  !count && app.$Progress.finish();
  return response;
});



// WEBPACK FOOTER //
// ./src/configProgressbar.js